var map = {
	"./15.mp3": "1282",
	"./16.mp3": "bf0b",
	"./17.mp3": "891b",
	"./18.mp3": "be81",
	"./19.mp3": "6321",
	"./20.mp3": "bdc8",
	"./21.mp3": "b9b4",
	"./22.mp3": "9fdc",
	"./23.mp3": "eac7",
	"./24.mp3": "8e17",
	"./25.mp3": "6c14",
	"./26.mp3": "df07",
	"./27.mp3": "5d13",
	"./28.mp3": "510b",
	"./M_Brilliant.mp3": "3a8c",
	"./M_Excellent.mp3": "12dc",
	"./M_Fantastic.mp3": "3e49",
	"./M_Great.mp3": "5aec",
	"./M_Perfect.mp3": "2128",
	"./M_Think again.mp3": "f311",
	"./M_Try again.mp3": "91f1",
	"./M_Very good.mp3": "a55e",
	"./M_Well done.mp3": "8253",
	"./M_Work harder.mp3": "b0f7",
	"./click.mp3": "4c5a",
	"./false.mp3": "fcb1",
	"./true.mp3": "fae9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49d8";